class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    
    this.cartMain = document.getElementById('cart-main');
    this.cartDrawer = document.getElementById('cart-drawer');
    this.cartForm = document.getElementById('cart');
    this.cartEmptyMessage = document.getElementById('cart-empty-message');
    this.cartFooterContents = document.getElementById('cart-footer-contents');
    this.lineItemStatusElement = document.getElementById('shopping-cart-item-status');

    if (themeSettings.template_name === 'cart') {
      this.cartLocation = this.cartMain;
    } else {
      this.cartLocation = this.cartDrawer;
    }

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
    .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    // replace updateQuantity() when we support quantity validation
    // this.validateQuantity(event);
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    this.updateQuantity(
      index,
      inputValue,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-items', '.js-cart-footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  checkforEmptyCart() {
    if (this.querySelector('.js-cart-items-list').children.length === 0) {
      this.cartIsEmpty = true;
    } else {
      this.cartIsEmpty = false;
    }
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.cartLocation.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll('.js-cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors, this.currentItemCount);
          return;
        }

        this.cartLocation.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }

        this.updateLiveRegions(line, message, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0) {
          trapFocus(this.cartDrawer);
        }

        this.disableLoading();
        this.checkforEmptyCart();

        if (this.cartIsEmpty) {
          this.showEmptyCart();
        } else {
          this.hideEmptyCart();
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      }).catch((e) => {
        this.querySelectorAll('.js-loader-overlay').forEach((overlay) => overlay.classList.add('display--hidden'));
        const errors = document.getElementById('cart-errors');
        errors.textContent = window.cartStrings.error;
        console.error(e);
      }).finally(() => {
        this.disableLoading();
      });
  }

  updateLiveRegions(line, message, itemCount) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);

    if (lineItemError) {
      lineItemError.querySelector('.js-cart-item-error-text').textContent = message;
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  hideEmptyCart() {
    this.cartEmptyMessage.classList.add('display--hidden');
    this.cartForm.classList.remove('display--hidden');
    this.cartFooterContents.classList.remove('display--hidden');
    this.cartFooterContents.querySelector('.js-cart-checkout-button').removeAttribute('disabled');
    this.cartEmptyMessage.querySelectorAll('a').forEach(link => link.setAttribute("tabindex", "-1"));
  }

  showEmptyCart() {
    this.cartEmptyMessage.classList.remove('display--hidden');
    this.cartForm.classList.add('display--hidden');
    this.cartFooterContents.classList.add('display--hidden');
    this.cartFooterContents.querySelector('.js-cart-checkout-button').setAttribute('disabled', '');
    this.cartEmptyMessage.querySelectorAll('a').forEach(link => link.removeAttribute("tabindex"));
  }

  enableLoading(line) {
    const targetCartItem = this.querySelector(`#CartItem-${line}`);
    const loadingOverlay = targetCartItem.querySelector('.js-loader-overlay');

    targetCartItem.classList.add('cart-item--loading');
    loadingOverlay.classList.remove('display--hidden');

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.querySelectorAll('.js-cart-item').forEach((item) => {
      item.classList.remove('cart-item--loading');
      item.querySelector('.js-loader-overlay').classList.add('display--hidden');
    });
  }
}

customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'input',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER)
    );
  }
}

customElements.define('cart-note', CartNote);

class CartMain extends HTMLElement {
  constructor() {
    super();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-items',
        section: 'cart-items',
        selector: '.js-cart-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'cart-footer',
        section: 'cart-footer',
        selector: '.js-cart-footer-contents'
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-main', CartMain);
